import {
  CalendarToday,
  LocalShipping,
  LocationCity,
} from "@mui/icons-material";
import { Card, CardContent, Divider, Grid, Typography } from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";

const BiocharOrderDetailCard = ({ orderData }) => {
  const { t } = useTranslation();
  return (
    <div>
      <Card sx={{ mb: 3, mt: 2 }}>
        <CardContent>
          <Typography
            variant="h6"
            sx={{
              display: "flex",
              alignItems: "center",
              mb: 2,
            }}
          >
            <LocationCity sx={{ mr: 1 }} /> {orderData.plant_name}
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography variant="body2" color="text.secondary">
                <CalendarToday
                  sx={{ fontSize: "small", mr: 1, verticalAlign: "middle" }}
                />
                {t("Pickup Date")}
              </Typography>
              <Typography variant="subtitle2">
                {dayjs(orderData.pickup_date).format("DD MMM YYYY")}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2" color="text.secondary">
                {t("Total Quantity")}
              </Typography>
              <Typography variant="subtitle2">
                {orderData.total_quantity_kg || "N/A"} kg
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2" color="text.secondary">
                {t("Status")}
              </Typography>
              <Typography variant="subtitle2">
                {orderData.status || "N/A"}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2" color="text.secondary">
                <LocalShipping
                  sx={{ fontSize: "small", mr: 1, verticalAlign: "middle" }}
                />
                {t("Transporter")}
              </Typography>
              <Typography variant="subtitle2">
                {orderData.transporter_name || "N/A"}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2" color="text.secondary">
                {t("Transporter Mobile")}
              </Typography>
              <Typography variant="subtitle2">
                {orderData.transporter_mobile || "N/A"}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2" color="text.secondary">
                {t("Transporter Vehicle")}
              </Typography>
              <Typography variant="subtitle2">
                {orderData.transporter_vehicle_number || "N/A"}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2" color="text.secondary">
                {t("Driver Name")}
              </Typography>
              <Typography variant="subtitle2">
                {orderData.transporter_driver_name || "N/A"}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2" color="text.secondary">
                {t("Driver Mobile")}
              </Typography>
              <Typography variant="subtitle2">
                {orderData.transporter_driver_mobile || "N/A"}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
};

export default BiocharOrderDetailCard;
